import React from 'react';
import NextLink from 'next/link';
import { chakra, Link } from '@chakra-ui/react';
import {
  sendAnalyticsEvent,
  AnalyticsEventProps,
} from '../common/libs/googleAnalytics';
import { isoStringToYmd } from '../common/libs/date';
import { VideoArticle } from '../server/libs/videoArticles';
import VideoCard from './VideoCard';

export type VideoArticleSummaryProps = VideoArticle & {
  articleId: string;
  gaEventLabel?: string;
  additionalGaEvent?: AnalyticsEventProps;
  isMobile?: boolean;
  onClick?: (props: { videoId: string; articleId: string }) => void; // リンクの挙動を上書きしたい場合に使用
};

function VideoArticleSummary({
  articleId,
  videoId,
  name,
  organization,
  author,
  updateDate,
  additionalGaEvent,
  isMobile,
  onClick,
}: VideoArticleSummaryProps) {
  // 現在のところ特集ページ専用
  const linkPath = `/special/${articleId}/${videoId}`;
  const poster = `/api/video-article/view-poster/${articleId}/${videoId}`;
  return (
    <NextLink key={videoId} href={linkPath} passHref>
      <Link
        display="inline-block"
        color="inherit"
        _hover={{
          textDecoration: 'none',
        }}
        onClick={(e) => {
          sendAnalyticsEvent(
            'special_video',
            'click',
            `${articleId}_${videoId}`,
          );
          additionalGaEvent &&
            sendAnalyticsEvent(
              additionalGaEvent.category,
              additionalGaEvent.action,
              additionalGaEvent.label,
            );
          if (onClick) {
            onClick({ videoId, articleId });
            e.preventDefault();
            return;
          }
        }}
      >
        <VideoCard
          name={name}
          author={author}
          organization={organization}
          poster={poster}
          updateDate={isoStringToYmd(updateDate)}
          isMobile={isMobile}
        />
      </Link>
    </NextLink>
  );
}

const MemoizedVideoArticleSummary = React.memo(
  VideoArticleSummary,
  (prevProps, nextProps) => {
    return prevProps.videoId === nextProps.videoId;
  },
);

export default chakra(MemoizedVideoArticleSummary);
